
export const AuthValEscolar = ({ auth, handleChange, error }) => {
  return (<>
    <div className="row">
    <div className="col col-12 ">
      <h4>
      Declaració Vals escolars
      </h4>
      <p>

          De cara el curs que estàs matriculant, la Generalitat de Catalunya, torna a llançar una edició del <b>val escolar.</b><br/><br/>

          <b>Què suposa?</b> Que tindràs a la teva disposició dos vals per un import total de 60€.<br/>

          <b>Què haig de tenir en compte?</b> Fent la matrícula ja estàs pagant part del material didàctic que l’Institut et demanarà. Per tant, aquests vals escolars <b><u>no és necessari que els cedeixis al centre.</u></b><br/>

          <b>Què haig de fer, doncs?</b> Cal que activis i descarreguis els vals <u>per fer tu mateix/a la compra d’allò que encara et faci falta</u>. En <a href="https://valescolar.cat/" target="_blank">aquí</a> podràs fer les gestions.<br/>

          <b>Què puc comprar amb el val escolar?</b> Els vals es podran bescanviar per llibres, diccionaris, elements de papereria i escriptura, calculadores, motxilles i jocs educatius.<br/>

          <b>On podré bescanviar els vals?</b> Ho podràs fer en algun dels establiments adherits en aquesta campanya. Pots consultar quins són en <a href="https://www.valescolar.cat/establiments-adherits" target="_blank">aquí</a>.<br/>

      </p>

      <br/>

        <input type="checkbox" id="authValEscolar" name="authValEscolar" value={auth} checked={auth === "1" ? true : false } onChange={ (t) => { handleChange(t.target.value) } } required/>
        <label htmlFor="authValEscolar"> Marca aquesta casella per verificar que has llegit el missatge i que has entès la informació donada. </label>
        <span id="auhtValEscolar_ERROR" className="a-Form-error">{error}</span>

      <br />

    </div>
  </div>

    <br />
  </>)
}
